import { render, staticRenderFns } from "./InfiniteScrollLoader.vue?vue&type=template&id=29b5dbc8"
import script from "./InfiniteScrollLoader.vue?vue&type=script&lang=ts"
export * from "./InfiniteScrollLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports